<template>
  <div>
    <header><img-v3 :src="page.icon_url" /></header>
    <main>
      <p class="tip">{{ page.tip }}</p>
      <p class="desc" v-html="page.desc"></p>
    </main>
    <footer>
      <p :style="btn_style" @click="go">{{ download_button.title }}</p>
    </footer>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { post } from "../tools/request";
import { showAlertDialog, showLoadingToast, showToast } from "../tools/Tip";
import { setTitle } from "../tools/setTitle";
import { ends } from "../tools/constant";

export default {
  data() {
    return {
      timeId: null,
      page: { download_button: {} },
    };
  },
  computed: {
    ...mapState(["_ticket", "_product"]),
    download_button() {
      return this.page.download_button;
    },
    btn_style() {
      return {
        color: this.download_button.text_color,
        background: this.download_button.background_color,
      };
    },
  },
  methods: {
    go() {
      let up = new URLSearchParams(location.search);
      let country = up.get('location_country');
      const isGenerator = country === 'BR' && this._product === 2;
      let params = new URLSearchParams(location.search);
      let ticket = params.get('driverLeaderTicket');
      if (ends.isFleetApp || ends.isFleet) {
        let url = `${this.download_button.to[ends.isIOS ? 'ios' : 'android']}${location.search}&ticket=${ticket}`;
        const module = Fusion.loadModule("newPageModule");
        ends.inApp && module.openNewPage({
          url,
          back_to_fleethome: 1,
          tab_index: 2
        });
        !ends.inApp && location.replace(url);
      } else if (ends.isIOS) {
        location.href = isGenerator? this.linkGenerator(this.download_button.to.ios) : this.download_button.to.ios;
      } else {
        location.href = isGenerator? this.linkGenerator(this.download_button.to.android) : this.download_button.to.android;
      }
    },
    getPageConfig() {
      showLoadingToast(this, this.$t("加载中"));
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      post(process.env.DOWNLOAD_INFO, up)
        .then((data) => {
          this.page = data;
          data.title && setTitle(data.title);
          this.timeId = setTimeout(this.loopProcess, 3 * 1000);
          if(up.get('fleet') === 'ru-fe') {
            window.parent.postMessage({type:"downloadInfo",message:"close"},"https://fleet-ru.didiglobal.com")
            // window.parent.postMessage({type:"downloadInfo",message:"close"}, "https://pre-fleet-us.intra.didiglobal.com")
          } else if(up.get('fleet') === 'us-fe') {
            window.parent.postMessage({type:"downloadInfo",message:"close"},"https://fleet-us.didiglobal.com")
            window.parent.postMessage({type:"downloadInfo",message:"close"},"https://fleet-web-us.didiglobal.com")
            // window.parent.postMessage({type:"downloadInfo",message:"close"}, "https://pre-fleet-us.intra.didiglobal.com")
          }
        })
        .catch((err) => {
          const { errmsg } = err;
          showAlertDialog(this, errmsg);
        })
        .finally(() => {
          this.toast.hide();
        });
    },

    loopProcess() {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      post(process.env.GET_PROGRESS_URL, up)
        .then((data) => {
          if (data.progress !== "downloadInfo") {
            this.leave();
            this.$router.replace({ name: "home" });
          } else {
            this.timeId = setTimeout(this.loopProcess, 5 * 1000);
          }
        })
        .catch((err) => console.log(err));
    },
    leave() {
      clearTimeout(this.timeId);
    },
    linkGenerator(url) {
      const onelinkGenerator =  new window.AF.OneLinkUrlGenerator({
        oneLinkURL: url,
        pidKeysList: ['source'],
        // pidOverrideList: {
        //   'joveo': 'joveo_int',
        //   'jampp': 'jampp_int',
        //   'google': 'googleadwords_int',
        //   'facebook':'Facebook Ads'
        // },
        campaignKeysList: ['utm_campaign']
      });
      onelinkGenerator.setChannel("utm_source"); // Input value
      onelinkGenerator.setCustomParameter("campaign_id", "af_c_id"); // Input Output value
      onelinkGenerator.setAdset("ad_group_id");
      onelinkGenerator.setAd("creative_id");
      onelinkGenerator.setCustomParameter("keyword", "af_keywords");
      onelinkGenerator.setCustomParameter("adposition", "af_siteid");
      onelinkGenerator.setAfSub1("gclid");
      onelinkGenerator.setAfSub2("fbclid");
      return onelinkGenerator.generateUrl();
    }
  },
  beforeDestroy() {
    this.leave();
  },
  mounted() {
    this.timeId = setTimeout(this.getPageConfig, 0);
  },
};
</script>
<style lang="less" scoped>
img:not([src]) {
  opacity: 0;
}
header {
  padding-top: 0.01rem;
}
header img {
  display: block;
  width: 2.8rem;
  height: 3.86rem;
  margin: 1.13rem auto 0;
}
main {
  padding: 0.01rem 0.6rem 1.95rem;
  p.tip {
    margin-top: 0.2rem;
    font-size: 0.48rem;
    font-weight: 500;
    line-height: 0.56rem;
    color: #0f1928;
    text-align: center;
  }
  p.desc {
    margin-top: 0.25rem;
    font-size: 0.28rem;
    line-height: 0.4rem;
    color: #666666;
  }
}
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1.72rem;
  box-sizing: border-box;
  padding: 0.32rem;
  box-shadow: 0 -0.2rem 0.2rem 0 rgba(0, 0, 0, 0.04);
  p {
    font-size: 0.36rem;
    font-weight: bold;
    line-height: 1.08rem;
    text-align: center;
    border-radius: 0.12rem;
  }
}
</style>
